(function (angular, app) {
    "use strict";

    angular.module(app.modules.outing.name)
       .controller(app.modules.outing.routes.detail.controller, OutingDetailController)


    OutingDetailController.$inject = ["$scope", "$sce", "$timeout", "ngDialog", "$routeParams", "$q"
       , app.modules.common.constants.appsettings
       , app.modules.outing.services.outings
       , app.modules.scoring.services.gamescore
       , app.modules.invitation.services.invite
       , app.modules.group.services.groups
       , app.modules.member.services.search
       , app.modules.common.constants.appmessaging
       , app.modules.common.services.functions
       , app.modules.common.services.storage
       , app.modules.invitation.services.invite
       , app.modules.ui.services.alerts
       , app.modules.common.constants.themelist,
        'Memory'
    ];


    function OutingDetailController($scope, $sce, $timeout, ngDialog, $routeParams, $q
       , ggAppSettings
       , ggOutingSvc
       , ggScoringSvc
       , ggInviteSvc
       , ggGroupSvc
       , ggMemberSearchSvc
       , ggMessaging
       , ggFunctions
       , ggStorage
       , ggInvitationSvc
       , ggAlertSvc
       , ggThemes,
        Memory
    ) {
        var ctrl = this, rDateExtract = /^(\d{4})-(\d{2})-(\d{2})/, vm = $scope.vm = {};

        // Scope Services
        $scope.PopupAlert = new ggAlertSvc.popup;
        $scope.Player = null;

        $scope.Temp = {
            isLoaded: false
           , isSwiper: false
           , isJumboExpanded: false
           , isNew: false
           , teeTimeId: 0
           , courseId: 0
           , roundId: 0
           , myPlayerId: 0
           , invitationId: 0
           , leaderboard: {
               isWagers: false
              , gameId: 0
              , roundId: 0
           }
           , roundDate: null
           , themes: ggThemes
           , types: app.modules.outing.types
           , handicapTypes: app.modules.group.constants.handicapTypes
           , isGroupMember: false
           , Score: {
               teeTimeId: 0
              , roundId: 0
              , teeId: 0
              , courseId: 0
              , memberId: 0
              , gender: "Male"
              , playerId: 0
              , teamId: 0
              , isTeamScore: false
              , isCombinedScore: false
           }
        }

        $scope.Outing = null;
        $scope.Course = null;
        $scope.Round = null;
        $scope.View = {
            tabs: {
                current: 1
               , types: {
                   home: 1
                  , invited: 2
                  , organize: 3
                  , leaderboard: 4,
                   memories: 5
               }
               , isActive: function (tab) {
                   return tab == $scope.View.tabs.current;
               }
               , select: function (tab) {
                   $scope.View.tabs.current = tab;
                   if (tab == $scope.View.tabs.types.invited) {
                      // $scope.Content.invited.fetch();
                   }
                   if (tab == $scope.View.tabs.types.organize) {
                       $scope.Content.organize.round.tabs.select(0);
                   }
                   if (tab == $scope.View.tabs.types.leaderboard) {
                       $scope.Content.leaderboard.fetch()
                   }
                   if (tab == $scope.View.tabs.types.memories) {
                       if (!vm.memories) {
                           vm.getMemoryList();
                       }
                   }
               }
            }
        }

        $scope.Content = {
            init: function () {

                // Check Group Membership
                var isGroupMember = function () {
                    var isMember = false;
                    var processData = function (storeData) {
                        if (storeData.length > 0) {
                            for (var s = 0; s < storeData.length; s++) {
                                if (storeData[s].id == $scope.Outing.group.id) {
                                    $scope.Temp.isGroupMember = true;
                                    break;
                                }
                            }
                        }
                        if (isMember) {
                            $scope.Temp.isGroupMember = true;
                        }
                        return $q.resolve();
                    }

                    var isCurrent = ggStorage.get(ggStorage.keys.groups.my.isCurrent);
                    var storeData = JSON.parse(ggStorage.get(ggStorage.keys.groups.my.data)) || [];
                    if (!isCurrent || !storeData || (storeData && storeData.length == 0)) {
                        return app.Member.Network.Data.Groups.fetch(true).then(function (data) {
                            return processData(data);
                        });
                    } else {
                        return processData(storeData);
                    }
                }


                if ($scope.Outing) {
                    // Set player Id
                    for (var x = 0; x < $scope.Outing.players.length; x++) {
                        var player = $scope.Outing.players[x];
                        if (player.member.id == app.Member.Detail.id) {
                            $scope.Temp.myPlayerId = player.id;
                            break;
                        }
                    }

                    // Set Default Course
                    if ($scope.Outing.gameCourses && $scope.Outing.gameCourses.length > 0) {
                        $scope.Course = $scope.Outing.gameCourses[0];
                    }

                    // Set Default round
                    if ($scope.Outing.rounds && $scope.Outing.rounds.length > 0) {
                        $scope.Round = $scope.Outing.rounds[0];
                    }


                    // My Tee Times
                    if ($scope.Temp.myPlayerId) {
                        var myTeeTimes = [];
                        var r = 0;
                        var t = 0;
                        var p = 0;
                        for (r = 0; r < $scope.Outing.rounds.length; r++) {
                            var rnd = $scope.Outing.rounds[r];
                            for (t = 0; t < rnd.teeTimes.length; t++) {
                                var tt = rnd.teeTimes[t];
                                for (p = 0; p < tt.players.length; p++) {
                                    if (tt.players[p].id == $scope.Temp.myPlayerId) {
                                        myTeeTimes.push({ rix: r, tix: t });
                                    }
                                }
                            }
                        }

                        // Re-sort Round Teetimes based on myTeeTimes
                        if (myTeeTimes.length > 0) {
                            for (var mt = 0; mt < myTeeTimes.length; mt++) {
                                // only if the tt index is > 0
                                var rix = myTeeTimes[mt].rix;
                                var tix = myTeeTimes[mt].tix;
                                if (tix > 0) {
                                    // Copy item to beginning of array;
                                    $scope.Outing.rounds[rix].teeTimes.unshift($scope.Outing.rounds[rix].teeTimes[tix]);
                                    // Remove old item
                                    $scope.Outing.rounds[rix].teeTimes.splice($scope.Outing.rounds[rix].teeTimes[tix+1],1);
                                }
                            }
                        }

                    }


                    if (!$scope.f.isActive() && !$scope.f.isPageAdmin()) {
                        $scope.f.notAvailable(); // Page is not active
                        ggFunctions.toggleProcessing(false);
                    } else {
                        // If Player ? No, is Invited
                        $q.resolve().then(function () {
                            if (!$scope.f.isPlayer()) {
                                return isGroupMember();
                            }
                        }).finally(function () {
                            // page is loaded
                            ggFunctions.toggleProcessing(false);
                            $scope.Temp.isLoaded = true;

                            var tab = +$routeParams.tab;
                            if (tab) {
                                $scope.View.tabs.select(tab);
                            }
                            else if ($scope.Temp.isNew && $scope.Outing.rounds[0].teeTimes.length > 1 && $scope.f.isPageAdmin()) {
                                $scope.View.tabs.select($scope.View.tabs.types.invited);
                            }
                            else {
                                $scope.View.tabs.select($scope.View.tabs.types.home);
                            }

                        });
                    }
                } else {
                    $scope.f.notAvailable();
                }
            }
           , home: {
               tabs: {
                   currentIndex: 0
                  , select: function (tabIndex) {
                      $scope.Content.home.tabs.currentIndex = tabIndex;
                  }
                  , isActive: function (tabIndex) {
                      return tabIndex == $scope.Content.home.tabs.currentIndex;
                  }
                  , manage: function () {
                      $scope.Content.organize.tabs.select($scope.Content.organize.tabs.types.teetimes);
                      $scope.View.tabs.select($scope.View.tabs.types.organize);
                  }
               }
           }
           , invited: {
               playing: {
                  isSearch: true
                 , refreshHandicap: function () {

                     var btn2 = new ggAlertSvc.button;
                     btn2.name = "Cancel";

                     var btn1 = new ggAlertSvc.button;
                     btn1.name = "Continue";
                     btn1.callback = function () {
                         ggFunctions.toggleProcessing(true);
                         ggOutingSvc.setup.updateHandicaps({
                             outingId: $scope.Outing.id
                         }).then(function (data) {
                            
                         }, function (error) {

                         }).finally(function () {
                             $scope.Content.invited.fetch();
                             ggFunctions.toggleProcessing(false);
                         });
                     }

                     $scope.PopupAlert.warn("Confirm", "By updating every players handicap, all existing handicaps will be lost for this event.", [btn1, btn2]);



                 }
                 , select: function (player, index) {

                     //if (!$scope.Temp.isSwiper) {
                     $scope.Player = angular.copy(player);
                     $scope.Player.Temp = {
                         handicap: player.handicap
                        , isUpdateGroup: false
                     }

                     app.Member.Session.pageTemplates.fetch(app.modules.outing.templates.playerModal.templateId).then(function (template) {
                         if (isCordova && isCordovaReady) {
                            StatusBar.backgroundColorByHexString(app.Branding.hexModal);
                         }

                         var _playerModal = ngDialog.open({
                             template: template
                            , plain: true
                            , closeByEscape: false
                            , closeByDocument: false
                             , showClose: false
                            , className: "fullscreen"
                            , trapFocus: false
                            , scope: $scope
                         });

                         _playerModal.closePromise.then(function () {

                             if (isCordova && isCordovaReady) {
                                StatusBar.backgroundColorByHexString(app.Branding.hexBody);
                             }

                             if ($scope.Player.handicap != $scope.Player.Temp.handicap) {

                                 var post = {
                                     outingId: $scope.Outing.id
                                    , playerId: $scope.Player.id
                                    , form: {
                                        teamId: $scope.Player.teamId
                                       , teamOrder: $scope.Player.teamOrder
                                       , handicap: parseFloat($scope.Player.Temp.handicap)
                                       , effectiveOn: ggFunctions.formatDateString(null, 'yyyy-mm-dd', null)
                                       , isHandicapAdjusted: !$scope.Player.Temp.isUpdateGroup
                                    }
                                 }

                                 var isOK = true;
                                 var updatePlayerHandicap = function () {
                                     return ggOutingSvc.player.updatePlayer(post).then(function (data) {
                                         if (data && data.status == "200") {
                                             $scope.Content.invited.playing.results[index].handicap = post.form.handicap;
                                             $scope.Content.invited.playing.results[index].handicapType = post.form.handicapType;
                                             $scope.Content.invited.playing.results[index].effectiveOn = post.form.effectiveOn;
                                             $scope.Content.invited.playing.results[index].isHandicapAdjusted = post.form.isHandicapAdjusted;
                                         }
                                     }, function (error) {
                                         isOK = false;
                                         $scope.PopupAlert.fail("Error", "There was an error updating the player handicap.");
                                     });
                                 };

                                 var updateGroupHandicap = function () {
                                     return ggGroupSvc.membership.autoUpdateGroupHandicap({ groupId: $scope.Outing.group.id, memberId: $scope.Player.memberId, handicap: post.form.handicap, effectiveOn: null
                                     }).then(function (data) {
                                         if (data && data.status == "200") {

                                         } else {
                                             $scope.PopupAlert.fail("Error", data.statusMsg);
                                         }
                                         return;
                                     }, function (error) {
                                         isOK = false;
                                         $scope.PopupAlert.fail("Error", "There was an error updating the player handicap.");
                                         return;
                                     }).finally(function () {
                                         $scope.Content.invited.confirmed.swipe.selected = 0;
                                     });
                                 };

                                 updatePlayerHandicap().then(function () {
                                     if ($scope.Player.Temp.isUpdateGroup && isOK) {
                                         return updateGroupHandicap();
                                     } else {
                                         return $q.resolve();
                                     }
                                 }).finally(function () {
                                     $scope.Player = null;
                                 });

                             } else {
                                 $scope.Player = null
                             }

                         }).finally(function () {
                             $scope.Content.invited.playing.swipe.selected = 0;
                         });

                     });
                     //}
                 }
                 , remove: function (player, ix) {

                     var isOK = true;
                     var removePlayer = function (playerId) {
                         return ggOutingSvc.player.deletePlayer({
                             outingId: $scope.Outing.id, playerId: playerId
                         }).then(function (data) {
                             if (data && data.status == "204") {
                                 $scope.Content.invited.playing.results.splice(ix, 1);
                             }
                             return;
                         }, function (error) {
                             isOK = false;
                             $scope.PopupAlert.fail("Error", "There was an error removing the player.");
                             return;
                         });
                     }

                     var isPlayerOnSchedule = function (playerId) {
                         var rv = false;
                         var rounds = $scope.Outing.rounds;
                         for (var r = 0; r < rounds.length; r++) {
                             var round = rounds[r];
                             for (var t = 0; t < round.teeTimes.length; t++) {
                                 var teeTime = round.teeTimes[t];
                                 for (var p = 0; p < teeTime.players.length; p++) {
                                     var player = teeTime.players[p];
                                     if (player.id == playerId) {
                                         rv = true;
                                         break;
                                     }
                                 }
                             }
                         }
                         return rv;
                     }

                     if (!isPlayerOnSchedule(player.id)) {
                         ggFunctions.toggleProcessing(true);
                         removePlayer(player.id).then(function () {
                             if (isOK) {
                             }
                         }).finally(function () {
                             ggFunctions.toggleProcessing(false);
                         });
                     } else {
                         $scope.PopupAlert.warn("Player Scheduled", "You cannot remove a player that has a scheduled Tee Time.")
                     }

                 }
                 , swipe: {
                     selected: 0
                    , left: function (id) {
                        $scope.f.isSwiper();
                        $scope.Content.invited.playing.swipe.selected = id;
                    }
                       , right: function (id) {
                           $scope.f.isSwiper();
                           $scope.Content.invited.playing.swipe.selected = 0;
                       }
                       , isSelected: function (id) {
                           return id == $scope.Content.invited.playing.swipe.selected;
                       }
                 }

              }
              , fetch: function () {
                  // Players

                    $scope.Content.invited.playing.isSearch = false;
                    ggOutingSvc.player.fetchPlayers({ outingId: outingId }).then(function (data) {
                        if (data && data.status == "200") {

                            var lst = data.data.value;
                            var results = [];
                            for (var x = 0; x < lst.length; x++) {
                                results.push(lst[x])
                            }

                            // Sort on Lastname
                            results.sort(function (a, b) {
                                var d1 = a.member.lastName;
                                var d2 = b.member.lastName;
                                var v = d1 > d2 ? 1 : d1 < d2 ? -1 : 0;
                                return v;
                            });

                            $scope.Outing.players = results;

                        }
                    }).finally(function () {
                        $scope.Content.invited.playing.isSearch = true;
                    });
              }
           }
           , organize: {
               tabs: {
                   current: 1
                 , types: {
                     teetimes: 1
                    , games: 2
                    , players: 3
                    , teams: 4
                    , courses: 5
                    , invites: 6
                    , settings: 7
                 }
                  , isActive: function (t) {
                      return $scope.Content.organize.tabs.current == t;
                  }
                  , select: function (t) {
                      if (!t) {
                          t = $scope.Content.organize.tabs.current;
                      }
                      if (t == $scope.Content.organize.tabs.types.games) {
                          $scope.Content.organize.game.setup.fill();
                      }
                      if (t == $scope.Content.organize.tabs.types.settings) {
                          $scope.Content.organize.edit.fill();
                      }
                      if (t == $scope.Content.organize.tabs.types.teams) {
                          $scope.Content.organize.team.refreshPlayers()
                      }

                      $scope.Content.organize.tabs.current = t;
                  }
               }
              , edit: {
                  isDirty: false
                 , form: {
                     outingId: 0
                    , name: null
                    , description: null
                    , status: null
                    , classType: null
                    , themeId: null
                    , groupId: null
                    , handicapType: "Official"
                 }
                 , fill: function () {
                     // Populate edit form
                     $scope.Content.organize.edit.form.outingId = $scope.Outing.id;
                     $scope.Content.organize.edit.form.name = $scope.Outing.name;
                     $scope.Content.organize.edit.form.description = $scope.Outing.description;
                     $scope.Content.organize.edit.form.status = $scope.Outing.status;
                     $scope.Content.organize.edit.form.classType = $scope.Outing.class;
                     $scope.Content.organize.edit.form.themeId = $scope.Outing.themeId.toString();
                     $scope.Content.organize.edit.form.groupId = $scope.Outing.group.id;
                     $scope.Content.organize.edit.form.handicapType = $scope.Outing.handicapType;
                 }
                 , save: function (isValid) {
                     // Save Outin
                     $scope.Content.organize.editisDirty = true;
                     if (isValid) {
                         ggFunctions.toggleProcessing(true);

                         ggOutingSvc.setup.updateOuting($scope.Content.organize.edit.form).then(function (data) {
                             if (data && data.status == "200") {

                                 // Coby back to scope.
                                 $scope.Outing.name = $scope.Content.organize.edit.form.name;
                                 $scope.Outing.description = $scope.Content.organize.edit.form.description;
                                 $scope.Outing.status = $scope.Content.organize.edit.form.status;
                                 $scope.Outing.class = $scope.Content.organize.edit.form.classType;
                                 $scope.Outing.themeId = $scope.Content.organize.edit.form.themeId;
                                 $scope.Outing.groupId = $scope.Content.organize.edit.form.groupId;
                                 $scope.Outing.handicapType = $scope.Content.organize.edit.form.handicapType;

                                 $scope.PopupAlert.success("Saved!", "The outing was saved.  Tap the button to continue");
                             }
                         }, function (error) {
                             $scope.PopupAlert.fail("Error", "There was an error saving the form.");
                         }).finally(function () { ggFunctions.toggleProcessing(false); });
                     }
                 }
              }
              , round: {
                  tabs: {
                      currentIndex: 0
                     , isActive: function (tabIndex) {
                         return $scope.Content.organize.round.tabs.currentIndex == tabIndex;
                     }
                     , select: function (tabIndex) {
                         $scope.Content.organize.round.tabs.currentIndex = tabIndex;
                         $scope.Content.organize.round.setup.fill(tabIndex);
                     }
                  }
                 , setup: {
                     form: {
                         outingId: null
                        , roundId: null
                        , name: ""
                        , number: ""
                        , startOn: null
                        , endOn: null
                     }
                    , fill: function (roundIndex) {
                        var tmp = angular.copy($scope.Outing.rounds[roundIndex]);

                        $scope.Content.organize.round.setup.form.outingId = $scope.Outing.id;
                        $scope.Content.organize.round.setup.form.roundId = tmp.id;
                        $scope.Content.organize.round.setup.form.name = tmp.name;
                        $scope.Content.organize.round.setup.form.number = tmp.number;
                        $scope.Content.organize.round.setup.form.startOn = tmp.startOn;
                        $scope.Content.organize.round.setup.form.endOn = tmp.startOn;
                    }
                    , isDateChanged: function () {
                        // compare dates
                        var date1 = ggFunctions.formatDateString($scope.Content.organize.round.setup.form.startOn, "yyyy-mm-dd", null);
                        var date2 = ggFunctions.formatDateString($scope.Outing.rounds[$scope.Content.organize.round.tabs.currentIndex].startOn, "yyyy-mm-dd", null);
                        return date1 != date2;
                    }
                    , newRound: function () {

                        var roundCount = $scope.Outing.rounds.length;
                        // You cannot do this (line below)!  You will get different dates in IE vs Chrome.  
                        // Chromes always assumes UTC.  IE will assume local since it does not have the "Z" suffix.
                        // var newDate = new Date(oldDate); 
                        // var oldDate = new Date($scope.Outing.rounds[roundCount - 1].startOn);
                        var oldDate = parseDate($scope.Outing.rounds[roundCount - 1].startOn);
                        var newDate = new Date(oldDate);

                        newDate.setDate(oldDate.getDate() + 1);
                        var tmp = {
                            name: "Round #" + (roundCount + 1)
                           , number: roundCount + 1
                           , startOn: ggFunctions.formatDateString(newDate, "yyyy-mm-dd", null)
                        }
                        $scope.Content.organize.round.setup.form.outingId = $scope.Outing.id;
                        $scope.Content.organize.round.setup.form.roundId = null;
                        $scope.Content.organize.round.setup.form.name = tmp.name;
                        $scope.Content.organize.round.setup.form.number = tmp.number;
                        $scope.Content.organize.round.setup.form.startOn = tmp.startOn;
                        $scope.Content.organize.round.setup.form.endOn = tmp.startOn;
                        $scope.Content.organize.round.setup.save();
                    }
                    , save: function () {

                        var roundIndex = $scope.Content.organize.round.tabs.currentIndex;
                        var isSaved = false;
                        var isNew = false;

                        var isValid = true;
                        var newDate = ggFunctions.formatDateString($scope.Content.organize.round.setup.form.startOn, "yyyy-mm-dd");
                        for (var r = 0; r < $scope.Outing.rounds.length; r++) {
                            var oldDate = ggFunctions.formatDateString($scope.Outing.rounds[r].startOn, "yyyy-mm-dd");
                            if (oldDate == newDate) {
                                //isValid = false;
                            }
                        }

                        var saveRound = function (form) {
                            if (form.roundId > 0) {
                                return ggOutingSvc.round.updateRound(form).then(function (data) {
                                    if (data && data.status == "200") {

                                        $scope.Outing.rounds[roundIndex].startOn = data.data.startOn;
                                        $scope.Outing.rounds[roundIndex].endOn = data.data.endOn;
                                        isSaved = true;
                                    }
                                });
                            } else {
                                return ggOutingSvc.round.insertRound(form).then(function (data) {
                                    if (data && data.status == "201") {
                                        $scope.Outing.rounds.push(data.data);
                                        isSaved = true;
                                        isNew = true;
                                    }
                                });
                            }
                        }

                        if (isValid) {
                            ggFunctions.toggleProcessing(true);
                            saveRound($scope.Content.organize.round.setup.form).then(function (data) {
                                return;
                            }).finally(function () {
                                ggFunctions.toggleProcessing(false);
                                if (isSaved) {
                                    if (!isNew) {
                                        $scope.Content.organize.round.tabs.select(roundIndex);
                                    } else {
                                        $scope.Content.organize.round.tabs.select($scope.Outing.rounds.length - 1);
                                    }

                                } else {
                                    $scope.PopupAlert.fail("Error", "There was an error saving the round.");
                                }
                            });

                        } else {
                            $scope.PopupAlert.warn("Warning", "You can only have one round per day for an outing.");
                        }
                    }
                    , deleteRound: function () {
                        var roundIndex = $scope.Content.organize.round.tabs.currentIndex;
                        ggFunctions.toggleProcessing(true);
                        ggOutingSvc.round.deleteRound({ outingId: $scope.Outing.id, roundId: $scope.Outing.rounds[roundIndex].id }).then(function (data) {
                            if (data) {
                                $scope.Outing.rounds.splice(roundIndex, 1);
                            }
                        }).finally(function () {
                            ggFunctions.toggleProcessing(false);
                            $scope.Content.organize.round.tabs.select(0);
                        })
                    }
                 }
                 , addPlayers: function (teeTimeId, players) {

                     // Array of data to send to api
                     var insertData = [];
                     var roundIndex = $scope.Content.home.tabs.currentIndex;
                     var round = $scope.Outing.rounds[roundIndex];

                     // check if player is on the schedule
                     var isPlayerOnSchedule = function (playerId) {
                         var rv = false;
                         for (var t = 0; t < round.teeTimes.length; t++) {
                             var teeTime = round.teeTimes[t];
                             for (var p = 0; p < teeTime.players.length; p++) {
                                 var player = teeTime.players[p];
                                 if (player.id == playerId) {
                                     rv = true;
                                     break;
                                 }
                             }
                         }
                         return rv;
                     }

                     var fetchRoundUpdate = function () {
                         return ggOutingSvc.teetime.fetchTeeTimes({ outingId: $scope.Outing.id, roundId: round.id }).then(function (data) {
                             if (data && data.status == "200") {
                                 $scope.Outing.rounds[roundIndex].teeTimes = data.data.value;
                             }
                             return;
                         });
                     }

                     // Loop through all selected players
                     for (var p = 0; p < players.length; p++) {
                         // Append form data.
                         if (!isPlayerOnSchedule(players[p].id)) {
                             var form = {
                                 playerId: players[p].id
                                , teeTimeId: teeTimeId
                                , outingId: $scope.Outing.id
                             }
                             insertData.push(form);
                         }
                     }
                     // Chain Insert
                     if (insertData.length > 0) {
                         var chain = ggFunctions.qSequence(ggOutingSvc.teetime.addPlayer, insertData);
                         ggFunctions.toggleProcessing(true);
                         chain.then(function () {
                             return fetchRoundUpdate();
                         }).finally(function () {
                             ggFunctions.toggleProcessing(false);
                         })
                     }
                 }
                 , removePlayer: function (teeTimeId, playerId) {
                     var form = {
                         outingId: $scope.Outing.id
                        , teeTimeId: teeTimeId
                        , playerId: playerId
                     }
                     var roundIndex = $scope.Content.home.tabs.currentIndex;
                     var round = $scope.Outing.rounds[roundIndex];
                     var isSaved = false;

                     var fetchRoundUpdate = function () {
                         return ggOutingSvc.teetime.fetchTeeTimes({ outingId: $scope.Outing.id, roundId: round.id }).then(function (data) {
                             if (data && data.status == "200") {
                                 $scope.Outing.rounds[roundIndex].teeTimes = data.data.value;
                             }
                             return;
                         });
                     }

                     var deletePlayer = function (form) {
                         return ggOutingSvc.teetime.deletePlayer(form).then(function (data) {
                             if (data) {
                                 isSaved = true;
                             }
                         }, function (error) {
                             return;
                         });
                     }
                     if (!$scope.f.isOutingEnded()) {
                         ggFunctions.toggleProcessing(true);
                         deletePlayer(form).then(function () {
                             return fetchRoundUpdate();
                         }).finally(function () {
                             ggFunctions.toggleProcessing(false);
                             if (!isSaved) {
                                 $scope.PopupAlert.fail("Error", "There was an error removing the player from the tee time.");
                             }
                             $scope.Content.organize.round.player.swipe.selected = 0;
                         });
                     } else {
                         $scope.PopupAlert.warn("Outing Ended", "You cannot remove a player from a teetime after the outing has ended.")
                     }
                 }
                 , removeTeam: function (teeTimeId, teamId) {
                     var form = {
                         outingId: $scope.Outing.id
                        , teeTimeId: teeTimeId
                        , teamId: teamId
                     }
                     var roundIndex = $scope.Content.home.tabs.currentIndex;
                     var round = $scope.Outing.rounds[roundIndex];
                     var isSaved = false;

                     var deletePlayerData = [];


                     var fetchRoundUpdate = function () {
                         return ggOutingSvc.teetime.fetchTeeTimes({ outingId: $scope.Outing.id, roundId: round.id }).then(function (data) {
                             if (data && data.status == "200") {
                                 $scope.Outing.rounds[roundIndex].teeTimes = data.data.value;
                             }
                             return;
                         });
                     }

                     // check if player is on the schedule
                     var isPlayerOnSchedule = function (playerId) {
                         var rv = false;
                         for (var t = 0; t < round.teeTimes.length; t++) {
                             var teeTime = round.teeTimes[t];
                             for (var p = 0; p < teeTime.players.length; p++) {
                                 var player = teeTime.players[p];
                                 if (player.id == playerId) {
                                     rv = true;
                                     break;
                                 }
                             }
                         }
                         return rv;
                     }

                     var deleteTeam = function (form) {
                         return ggOutingSvc.teetime.deleteTeam(form).then(function (data) {
                             if (data) {
                                 isSaved = true;
                             }
                         }, function (error) {
                             return;
                         });
                     }

                     // Loop through all selected team/players
                     var teams = $scope.Outing.teams;
                     for (var t = 0; t < teams.length; t++) {
                         // Append form data.
                         if (teams[t].id == teamId) {
                             for (var p = 0; p < teams[t].players.length; p++) {
                                 if (isPlayerOnSchedule(teams[t].players[p].id)) {
                                     var pform = {
                                         playerId: teams[t].players[p].id
                                        , teeTimeId: teeTimeId
                                        , outingId: $scope.Outing.id
                                     }
                                     deletePlayerData.push(pform);
                                 }
                             }
                         }
                     }


                     if (!$scope.f.isOutingEnded()) {

                         var pchain = ggFunctions.qSequence(ggOutingSvc.teetime.deletePlayer, deletePlayerData);

                         ggFunctions.toggleProcessing(true);
                         deleteTeam(form).then(function () {
                             return pchain;
                         }).then(function () {
                             return fetchRoundUpdate();
                         }).finally(function () {
                             ggFunctions.toggleProcessing(false);
                             if (!isSaved) {
                                 $scope.PopupAlert.fail("Error", "There was an error removing the team from the tee time.");
                             }
                             $scope.Content.organize.round.team.swipe.selected = 0;
                         });
                     } else {
                         $scope.PopupAlert.warn("Outing Ended", "You cannot remove a team from a teetime after the outing has ended.")
                     }
                 }
                 , addTeams: function (teeTimeId, teams) {

                     // Array of data to send to api
                     var insertTeamData = [];
                     var insertPlayerData = [];

                     var roundIndex = $scope.Content.organize.round.tabs.currentIndex;
                     var round = $scope.Outing.rounds[roundIndex];

                     var fetchRoundUpdate = function () {
                         return ggOutingSvc.teetime.fetchTeeTimes({ outingId: $scope.Outing.id, roundId: round.id }).then(function (data) {
                             if (data && data.status == "200") {
                                 $scope.Outing.rounds[roundIndex].teeTimes = data.data.value;
                             }
                             return;
                         });
                     }

                     // check if player is on the schedule
                     var isTeamOnSchedule = function (teamId) {
                         var rv = false;
                         for (var t = 0; t < round.teeTimes.length; t++) {
                             var teeTime = round.teeTimes[t];
                             for (var p = 0; p < teeTime.teams.length; p++) {
                                 var team = teeTime.teams[p];
                                 if (team.id == teamId) {
                                     rv = true;
                                     break;
                                 }
                             }
                         }
                         return rv;
                     }

                     // check if player is on the schedule
                     var isPlayerOnSchedule = function (playerId) {
                         var rv = false;
                         for (var t = 0; t < round.teeTimes.length; t++) {
                             var teeTime = round.teeTimes[t];
                             for (var p = 0; p < teeTime.players.length; p++) {
                                 var player = teeTime.players[p];
                                 if (player.id == playerId) {
                                     rv = true;
                                     break;
                                 }
                             }
                         }
                         return rv;
                     }

                     // Loop through all selected teams
                     for (var p = 0; p < teams.length; p++) {
                         // Append form data.
                         if (!isTeamOnSchedule(teams[p].id)) {
                             var form = {
                                 teamId: teams[p].id
                                , teeTimeId: teeTimeId
                                , outingId: $scope.Outing.id
                             }
                             insertTeamData.push(form);
                         }
                     }

                     // Loop through all selected team/players
                     for (var t = 0; t < teams.length; t++) {
                         // Append form data.
                         for (var p = 0; p < teams[t].players.length; p++) {
                             if (!isPlayerOnSchedule(teams[t].players[p].id)) {
                                 var form = {
                                     playerId: teams[t].players[p].id
                                    , teeTimeId: teeTimeId
                                    , outingId: $scope.Outing.id
                                 }
                                 insertPlayerData.push(form);
                             }
                         }
                     }


                     // Chain Insert
                     if (insertTeamData.length > 0) {
                         var tchain = ggFunctions.qSequence(ggOutingSvc.teetime.addTeam, insertTeamData);
                         var pchain = ggFunctions.qSequence(ggOutingSvc.teetime.addPlayer, insertPlayerData);
                         ggFunctions.toggleProcessing(true);
                         tchain.then(function () {
                             return pchain;
                         }).then(function () {
                             return fetchRoundUpdate();
                         }).finally(function () {
                             ggFunctions.toggleProcessing(false);
                         })
                     }
                 }
                 , player: {
                     select: function (id) {
                         // What do we do?
                     }
                    , swipe: {
                        selected: 0
                       , left: function (id) {
                           $scope.f.isSwiper();
                           $scope.Content.organize.round.player.swipe.selected = id;
                       }
                       , right: function (id) {
                           $scope.f.isSwiper();
                           $scope.Content.organize.round.player.swipe.selected = 0;
                       }
                       , isSelected: function (id) {
                           return id == $scope.Content.organize.round.player.swipe.selected;
                       }
                    }
                 }
                 , team: {
                     select: function (id) {
                         // What do we do?
                     }
                    , swipe: {
                        selected: 0
                       , left: function (id) {
                           $scope.f.isSwiper();
                           $scope.Content.organize.round.team.swipe.selected = id;
                       }
                       , right: function (id) {
                           $scope.f.isSwiper();
                           $scope.Content.organize.round.team.swipe.selected = 0;
                       }
                       , isSelected: function (id) {
                           return id == $scope.Content.organize.round.team.swipe.selected;
                       }
                    }
                 }

                 , teetime: {
                     selected: 0
                       , toggle: function (teeTime) {
                           $scope.Content.organize.round.teetime.swipe.selected = 0;
                           if (teeTime.id != $scope.Content.organize.round.teetime.selected) {
                               $scope.Content.organize.round.teetime.selected = teeTime.id;
                               $scope.Content.organize.round.teetime.fill(teeTime);
                           } else {
                               $scope.Content.organize.round.teetime.selected = 0;
                           }

                       }
                       , isActive: function (id) {
                           return id == $scope.Content.organize.round.teetime.selected;
                       }
                       , form: {
                           gameCourseId: "0"
                          , roundId: 0
                          , startingTime: null
                          , startingHole: 1
                          , teeTimeNumber: 1
                       }
                       , fill: function (teeTime) {
                           if (teeTime) {
                               $scope.Content.organize.round.teetime.form.gameCourseId = teeTime.gameCourseId.toString();
                               $scope.Content.organize.round.teetime.form.roundId = teeTime.roundId;
                               $scope.Content.organize.round.teetime.form.startingTime = teeTime.startingTime;
                               $scope.Content.organize.round.teetime.form.startingHole = teeTime.startingHole.toString();
                               $scope.Content.organize.round.teetime.form.teeTimeNumber = teeTime.teeTimeNumber;
                           } else {
                               $scope.Content.organize.round.teetime.form.gameCourseId = $scope.Course.id;
                               $scope.Content.organize.round.teetime.form.roundId = $scope.Outing.rounds[$scope.Content.organize.round.tabs.currentIndex].id;
                               $scope.Content.organize.round.teetime.form.startingTime = null;
                               $scope.Content.organize.round.teetime.form.startingHole = 1;
                               $scope.Content.organize.round.teetime.form.teeTimeNumber = 1;
                           }
                       }
                       , newTeeTime: function () {

                           $scope.Content.organize.round.teetime.selected = 0;

                           var roundIndex = $scope.Content.organize.round.tabs.currentIndex;
                           var teeTimeCount = 0;
                           var startingTime = "08:00 AM"
                           var courseId = $scope.Course.id;

                           if ($scope.Outing.rounds[roundIndex].teeTimes && $scope.Outing.rounds[roundIndex].teeTimes.length > 0) {
                               teeTimeCount = $scope.Outing.rounds[roundIndex].teeTimes.length;
                               // get latest teeTimeTime
                               startingTime = $scope.Outing.rounds[roundIndex].teeTimes[teeTimeCount - 1].startingTime;

                               // Add 10 Minutes
                               startingTime = ggFunctions.parseDBTime(startingTime, false);

                               var startingDate = new Date('1/1/2016 ' + startingTime);

                               startingTime = new Date(startingDate.getTime() + (10 * 60000));

                               // Format back into time
                               startingTime = dateFormat(startingTime, "h:MM:ss TT")

                               // Last CourseId
                               courseId = $scope.Outing.rounds[roundIndex].teeTimes[teeTimeCount - 1].gameCourseId;

                           }



                           $scope.Content.organize.round.teetime.form.outingId = $scope.Outing.id; // Outing
                           $scope.Content.organize.round.teetime.form.roundId = $scope.Outing.rounds[roundIndex].id; // current round
                           $scope.Content.organize.round.teetime.form.gameCourseId = courseId; // Previous TeeTime CourseId
                           $scope.Content.organize.round.teetime.form.startingTime = startingTime;
                           $scope.Content.organize.round.teetime.form.startingHole = 1; // Default
                           $scope.Content.organize.round.teetime.form.teeTimeNumber = teeTimeCount + 1;
                           $scope.Content.organize.round.teetime.save();
                       }
                       , save: function () {

                           var roundIndex = $scope.Content.organize.round.tabs.currentIndex;
                           var isSaved = false;
                           var isValid = true;
                           // Validate Time.  One Time per round
                           var newTime = dateFormat("1/1/2016 " + $scope.Content.organize.round.teetime.form.startingTime, "h:MM:ss TT");
                           if ($scope.Outing.rounds[roundIndex].teeTimes) {
                               for (var t = 0; t < $scope.Outing.rounds[roundIndex].teeTimes.length; t++) {
                                   var oldTime = dateFormat("1/1/2016 " + $scope.f.renderTime($scope.Outing.rounds[roundIndex].teeTimes[t].startingTime), "h:MM:ss TT");
                                   if (newTime == oldTime) {
                                       isValid = false;
                                   }
                               }
                           }
                           isValid = true;

                           // Need to update round after update
                           var fetchRoundUpdate = function () {
                               return ggOutingSvc.teetime.fetchTeeTimes({ outingId: $scope.Outing.id, roundId: $scope.Outing.rounds[roundIndex].id }).then(function (data) {
                                   if (data && data.status == "200") {
                                       $scope.Outing.rounds[roundIndex].teeTimes = data.data.value;
                                   }
                                   return;
                               });
                           }
                           // Update APi
                           var saveTeeTime = function (form) {
                               if (form.teeTimeId > 0) {
                                   return ggOutingSvc.teetime.updateTeeTime(form).then(function (data) {
                                       if (data) {
                                           isSaved = true;
                                       }
                                   }, function (error) {
                                       return;
                                   });
                               } else {
                                   return ggOutingSvc.teetime.insertTeeTime(form).then(function (data) {
                                       if (data) {
                                           isSaved = true;
                                       }
                                   }, function (error) {
                                       return;
                                   });
                               }
                           }


                           if (isValid) {
                               var form = angular.copy($scope.Content.organize.round.teetime.form);
                               form.outingId = $scope.Outing.id;
                               form.teeTimeId = $scope.Content.organize.round.teetime.selected;

                               ggFunctions.toggleProcessing(true);
                               saveTeeTime(form).then(function () {
                                   return fetchRoundUpdate();
                               }).finally(function () {
                                   ggFunctions.toggleProcessing(false);
                                   if (!isSaved) {
                                       $scope.PopupAlert.fail("Error", "There was an error inserting the tee time.");
                                   } else {
                                       $scope.Content.organize.round.teetime.toggle($scope.Content.organize.round.teetime.selected);
                                   }
                               });
                           }

                       }
                       , delete: function (teeTime) {

                           var roundId = teeTime.roundId;
                           var roundIndex = $scope.Content.organize.round.tabs.currentIndex;
                           var isUpdated = false;

                           var fetchRoundUpdate = function () {
                               return ggOutingSvc.teetime.fetchTeeTimes({ outingId: $scope.Outing.id, roundId: roundId }).then(function (data) {
                                   if (data && data.status == "200") {
                                       $scope.Outing.rounds[roundIndex].teeTimes = data.data.value;
                                   }
                                   return;
                               });
                           }

                           var deleteTeeTime = function () {
                               return ggOutingSvc.teetime.deleteTeeTime({ outingId: $scope.Outing.id, teeTimeId: teeTime.id }).then(function (data) {
                                   if (data) {
                                       isUpdated = true;
                                   }
                                   return;
                               });
                           }

                           if (!teeTime.players || teeTime.players.length == 0) {

                               ggFunctions.toggleProcessing(true);
                               deleteTeeTime().then(function () {
                                   return fetchRoundUpdate();
                               }).finally(function () {
                                   ggFunctions.toggleProcessing(false);
                                   if (!isUpdated) {
                                       $scope.PopupAlert.warn("Warning", "There was an error deleting the tee time.");
                                   }
                               });

                           } else {
                               $scope.PopupAlert.warn("Warning", "You cannot delete a tee time when a player has been assigned.");
                           }


                       }
                       , swipe: {
                           selected: 0
                          , left: function (id) {
                              $scope.f.isSwiper();
                              $scope.Content.organize.round.teetime.selected = 0;
                              $scope.Content.organize.round.teetime.swipe.selected = id;
                          }
                          , right: function (id) {
                              $scope.f.isSwiper();
                              $scope.Content.organize.round.teetime.swipe.selected = 0;
                          }
                          , isSelected: function (id) {
                              return id == $scope.Content.organize.round.teetime.swipe.selected;
                          }
                       }
                 }
              }
              , game: {
                  tabs: {
                      currentIndex: 0
                     , isActive: function (tabIndex) {
                         return $scope.Content.organize.game.tabs.currentIndex == tabIndex;
                     }
                     , select: function (tabIndex) {
                         $scope.Content.organize.game.tabs.currentIndex = tabIndex;
                         $scope.Content.organize.game.setup.fill();
                     }
                  }
                 , setup: {
                     types: app.modules.outing.types
                    , form: {
                        id: 0
                       , outingId: 0
                       , name: "Game #1"
                       , gameType: "Individual"
                       , holeType: "EighteenHoles"
                       , scoringType: "Stroke"
                       , pointType: "None"
                       , isMain: false
                       , isNet: false
                       , isLowHandicap: false
                       , isSkins: false
                       , isWager: false
                       , maxSkinStrokes: null
                       , bestBallCount: 1
                       , bestBalls: app.modules.outing.constants.defaultBestBalls
                       , points: app.modules.outing.constants.defaultPoints

                    }
                    , fill: function (tabIndex) {

                        var gameIndex = $scope.Content.organize.game.tabs.currentIndex;
                        var game = angular.copy($scope.Outing.games[gameIndex]);
                        $scope.Content.organize.game.setup.form.id = game.id;
                        $scope.Content.organize.game.setup.form.outingId = $scope.Outing.id;
                        $scope.Content.organize.game.setup.form.name = game.name;
                        $scope.Content.organize.game.setup.form.gameType = game.gameType || "Individual";
                        $scope.Content.organize.game.setup.form.holeType = game.holeType || "EighteenHoles";
                        $scope.Content.organize.game.setup.form.scoringType = game.scoringType || "Stroke";
                        $scope.Content.organize.game.setup.form.pointType = game.pointType || "None";
                        $scope.Content.organize.game.setup.form.isMain = game.isMain;
                        $scope.Content.organize.game.setup.form.isNet = game.isNet;
                        $scope.Content.organize.game.setup.form.isLowHandicap = game.isLowHandicap;
                        $scope.Content.organize.game.setup.form.isSkins = game.isSkins;
                        $scope.Content.organize.game.setup.form.isWager = game.isWager;
                        $scope.Content.organize.game.setup.form.maxSkinStrokes = game.maxSkinStrokes;
                        $scope.Content.organize.game.setup.form.bestBallCount = 1;
                        $scope.Content.organize.game.setup.form.bestBalls = game.bestBalls || app.modules.outing.constants.defaultBestBalls;
                        $scope.Content.organize.game.setup.form.points = game.points || app.modules.outing.constants.defaultPoints;
                    }
                    , save: function () {

                        var frm = angular.copy($scope.Content.organize.game.setup.form);
                        var isSaved = false;

                        var saveGame = function (form) {
                            if (form.id > 0) {
                                return ggOutingSvc.game.updateGame(form).then(function (data) {
                                    if (data && data.status == "200") {
                                        isSaved = true;
                                        // copy back
                                    }
                                    return;
                                }, function (error) {
                                    return;
                                })
                            } else {
                                return ggOutingSvc.game.insertGame(form).then(function (data) {
                                    if (data && data.status == "201") {
                                        isSaved = true;
                                        $scope.Outing.games.push(data.data);
                                        $scope.Content.organize.game.tabs.select($scope.Outing.games.length - 1);
                                    }
                                    return;
                                }, function (error) {
                                    return;
                                })
                            }
                        }
                        var fetchGames = function () {
                            return ggOutingSvc.game.fetchGames({ outingId: outingId }).then(function (data) {
                                if (data && data.status == "200") {
                                    $scope.Outing.games = data.data.value;
                                }
                                return;
                            }, function (error) {
                                return;
                            });
                        }

                        ggFunctions.toggleProcessing(true);
                        saveGame(frm).then(function () {
                            return fetchGames();
                        }).finally(function () {
                            ggFunctions.toggleProcessing(false);
                            if (isSaved) {
                                 $scope.PopupAlert.success("Saved!", "The game has been saved.");
                                
                            } else {
                                $scope.PopupAlert.fail("Error", "There was an error saving the game.");
                            }
                        });

                    }
                    , addNewGame: function () {
                        // copy primary game
                        var game = angular.copy($scope.Outing.games[0]);
                        $scope.Content.organize.game.setup.form.id = 0;
                        $scope.Content.organize.game.setup.form.outingId = game.outingId;
                        $scope.Content.organize.game.setup.form.name = "Game #" + ($scope.Outing.games.length + 1);
                        $scope.Content.organize.game.setup.form.gameType = game.gameType || "Individual";
                        $scope.Content.organize.game.setup.form.holeType = game.holeType || "EighteenHoles";
                        $scope.Content.organize.game.setup.form.scoringType = game.scoringType || "Stroke";
                        $scope.Content.organize.game.setup.form.pointType = game.pointType || "None";
                        $scope.Content.organize.game.setup.form.isMain = false; //game.isMain;
                        $scope.Content.organize.game.setup.form.isNet = game.isNet;
                        $scope.Content.organize.game.setup.form.isSkins = game.isSkins;
                        $scope.Content.organize.game.setup.form.isWager = game.isWager;
                        $scope.Content.organize.game.setup.form.maxSkinStrokes = game.maxSkinStrokes;
                        $scope.Content.organize.game.setup.form.bestBallCount = 1;
                        $scope.Content.organize.game.setup.form.bestBalls = game.bestBalls;
                        $scope.Content.organize.game.setup.form.points = game.points;
                        $scope.Content.organize.game.setup.save();
                    }
                    , deleteGame: function () {

                        var gameIndex = $scope.Content.organize.game.tabs.currentIndex;

                        var form = {
                            id: $scope.Content.organize.game.setup.form.id
                           , outingId: $scope.Outing.id
                        }

                        ggFunctions.toggleProcessing(true);
                        ggOutingSvc.game.deleteGame(form).then(function (data) {
                            if (data && data.status == "204") {
                                // Save to form.
                                $scope.Content.organize.game.current = null;
                                if (gameIndex > -1) {
                                    $scope.Outing.games.splice(gameIndex, 1);
                                    $scope.Content.organize.game.tabs.select(0);
                                }
                            }
                        }, function (error) {
                            $scope.PopupAlert.fail("Error", error.statusText);
                        }).finally(function () { ggFunctions.toggleProcessing(false); });

                    }
                 }
                 , player: {
                     select: function () {
                         // Do Nothing

                     }
                    , swipe: {
                        selected: 0
                       , left: function (id) {
                           $scope.f.isSwiper();
                           $scope.Content.organize.game.player.swipe.selected = id;
                       }
                       , right: function (id) {
                           $scope.f.isSwiper();
                           $scope.Content.organize.game.player.swipe.selected = 0;
                       }
                       , isSelected: function (id) {
                           return id == $scope.Content.organize.game.player.swipe.selected;
                       }
                    }

                 }
                 , team: {
                     add: function (gameId, teamId) {

                         var form = {
                             outingId: $scope.Outing.id
                            , teamId: teamId
                            , gameId: gameId
                         }

                         ggOutingSvc.game.addTeam(form).then(function (data) {
                             if (data && data.status == "200") {

                             }
                         }, function (error) { }).finally(function () {
                             ggFunctions.toggleProcessing(false);
                             ctrl.fetch.fetchGames($scope.Outing.id);
                         });
                     }
                    , clear: function (gameId) {

                        var promises = [];

                        var gameIndex = 0;
                        for (var r = 0; r < $scope.Outing.games.length; r++) {
                            var game = $scope.Outing.games[r];
                            if (game.id == gameId) {
                                gameIndex = r;
                            }
                        }

                        // remove all teams from game
                        for (var x = 0; x < $scope.Outing.games[gameIndex].teams.length; x++) {
                            var form = {
                                teamId: $scope.Outing.games[gameIndex].teams[x].id
                               , outingId: $scope.Outing.id
                               , gameId: gameId
                            }
                            var promise = ggOutingSvc.game.deleteTeam(form);
                            promises.push(promise)
                        }

                        // After all promises, refetch teetime players
                        $q.all(promises).then(function (data) {
                            ctrl.fetch.fetchGames($scope.Outing.id);
                        });
                    }
                    , addAll: function (gameId) {
                        var promises = [];

                        // add all teams to game
                        for (var x = 0; x < $scope.Outing.teams.length; x++) {
                            var form = {
                                teamId: $scope.Outing.teams[x].id
                               , outingId: $scope.Outing.id
                               , gameId: gameId
                            }
                            var promise = ggOutingSvc.game.addTeam(form);
                            promises.push(promise)
                        }

                        // After all promises, refetch teetime players
                        $q.all(promises).then(function (data) {
                            ctrl.fetch.fetchGames($scope.Outing.id);
                        });
                    }
                 }
                 , addPlayers: function (gameId, players) {

                     // Array of data to send to api
                     var insertData = [];
                     var gameIndex = $scope.Content.organize.game.tabs.currentIndex;
                     var game = $scope.Outing.games[gameIndex];

                     // check if player is on the schedule
                     var isPlayerOnGame = function (playerId) {
                         var rv = false;
                         for (var p = 0; p < game.players.length; p++) {
                             var player = game.players[p];
                             if (player.id == playerId) {
                                 rv = true;
                                 break;
                             }
                         }
                         return rv;
                     }

                     var fetchGameUpdate = function () {
                         return ggOutingSvc.game.fetchGames({ outingId: $scope.Outing.id }).then(function (data) {
                             if (data && data.status == "200") {
                                 $scope.Outing.games = data.data.value;
                             }
                             return;
                         });
                     }

                     // Loop through all selected players
                     for (var p = 0; p < players.length; p++) {
                         // Append form data.
                         if (!isPlayerOnGame(players[p].id)) {
                             var form = {
                                 playerId: players[p].id
                                , gameId: gameId
                                , outingId: $scope.Outing.id
                             }
                             insertData.push(form);
                         }
                     }
                     // Chain Insert
                     if (insertData.length > 0) {
                         var chain = ggFunctions.qSequence(ggOutingSvc.game.addPlayer, insertData);
                         ggFunctions.toggleProcessing(true);
                         chain.then(function () {
                             return fetchGameUpdate();
                         }).finally(function () {
                             ggFunctions.toggleProcessing(false);
                         })
                     }
                 }
                 , removePlayer: function (playerId) {
                     var form = {
                         outingId: $scope.Outing.id
                        , gameId: $scope.Outing.games[$scope.Content.organize.game.tabs.currentIndex].id
                        , playerId: playerId
                     }
                     var isSaved = false;
                     var fetchGameUpdate = function () {
                         return ggOutingSvc.game.fetchGames({ outingId: $scope.Outing.id }).then(function (data) {
                             if (data && data.status == "200") {
                                 $scope.Outing.games = data.data.value;
                             }
                             return;
                         });
                     }

                     var deletePlayer = function (form) {
                         return ggOutingSvc.game.deletePlayer(form).then(function (data) {
                             if (data) {
                                 isSaved = true;
                             }
                         }, function (error) {
                             return;
                         });
                     }

                     ggFunctions.toggleProcessing(true);
                     deletePlayer(form).then(function () {
                         return fetchGameUpdate();
                     }).finally(function () {
                         ggFunctions.toggleProcessing(false);
                         if (!isSaved) {
                             $scope.PopupAlert.fail("Error", "There was an error removing the player from the game.");
                         }
                     });
                 }
                 , isGameRound: function (roundId) {
                    var rv = false;
                    if ($scope.Outing.games && $scope.Outing.games[$scope.Content.organize.game.tabs.currentIndex]) {
                       var game = $scope.Outing.games[$scope.Content.organize.game.tabs.currentIndex];
                       if (game && game.rounds) {
                          for (var r = 0; r < game.rounds.length; r++) {
                             if (game.rounds[r].id == roundId) {
                                rv = true;
                                break;
                             }
                          }
                       }
                       
                    }
                    

                    return rv;
                 }
                 , toggleRound: function (roundId) {


                    var form = {
                       outingId: $scope.Outing.id
                        , gameId: $scope.Outing.games[$scope.Content.organize.game.tabs.currentIndex].id
                        , roundId: roundId
                    }

                    var isSaved = false;
                    var fetchGameUpdate = function () {
                       return ggOutingSvc.game.fetchGames({ outingId: $scope.Outing.id }).then(function (data) {
                          if (data && data.status == "200") {
                             $scope.Outing.games = data.data.value;
                          }
                          return;
                       });
                    }

                    var addRound = function (form) {
                       return ggOutingSvc.game.addRound(form).then(function (data) {
                          if (data) {
                             isSaved = true;
                          }
                       }, function (error) {
                          return;
                       });
                    }

                    var deleteRound = function (form) {
                       return ggOutingSvc.game.deleteRound(form).then(function (data) {
                          if (data) {
                             isSaved = true;
                          }
                       }, function (error) {
                          return;
                       });
                    }

                    var updateRound = addRound;

                    if ($scope.Content.organize.game.isGameRound(roundId)) {
                       updateRound = deleteRound;
                    }

                    ggFunctions.toggleProcessing(true);
                    updateRound(form).then(function () {
                       return fetchGameUpdate();
                    }).finally(function () {
                       ggFunctions.toggleProcessing(false);
                       if (!isSaved) {
                          $scope.PopupAlert.fail("Error", "There was an error removing the round from the game.");
                       }
                    });
                 }
              }
              , team: {
                  refreshPlayers: function () {
                      return ggOutingSvc.player.fetchPlayers({ outingId: outingId }).then(function (data) {
                          if (data && data.status == "200") {
                              $scope.Outing.players = data.data.value;
                          }
                          return;
                      });
                  }
                 , setup: {
                     insert: function () {
                         // get max sort to determine team name
                         var sortOrder = 0;
                         if ($scope.Outing.teams.length > 0) {
                             sortOrder = $scope.Outing.teams[$scope.Outing.teams.length - 1].sortOrder;
                         }

                         var form = {
                             outingId: $scope.Outing.id
                            , teamId: 0
                            , name: "#" + app.modules.outing.types.alpha[sortOrder]
                            , sortOrder: sortOrder + 1
                         }

                         ggFunctions.toggleProcessing(true);
                         ggOutingSvc.team.insertTeam(form).then(function (data) {
                             if (data && data.status == "201") {
                                 form.id = data.data.id;
                                 form.players = [];
                                 $scope.Outing.teams.push(form);
                             }
                         }
                         , function (error) {
                             $scope.PopupAlert.fail("Error", "There was an error inserting the team");
                         }).finally(function () {
                             ggFunctions.toggleProcessing(false);
                         });
                     }
                    , remove: function (teamId) {
                        ggFunctions.toggleProcessing(true);
                        ggOutingSvc.team.deleteTeam({ outingId: $scope.Outing.id, teamId: teamId }).then(function (data) {
                            if (data) {
                                for (var t = 0; t < $scope.Outing.teams.length; t++) {
                                    var team = $scope.Outing.teams[t];
                                    if (team.id == teamId) {
                                        $scope.Outing.teams.splice(t, 1);
                                    }
                                }
                            }
                        }
                        , function (error) {
                            $scope.PopupAlert.fail("Error", "There was an error removing the team");
                        }).finally(function () {
                            ggFunctions.toggleProcessing(false);
                        });
                    }
                 }
                 , player: {
                     remove: function (teamId, player) {
                         var post = {
                             outingId: $scope.Outing.id
                            , playerId: player.id
                            , form: {
                                teamId: null
                               , teamOrder: null
                               , handicap: player.handicap
                               , handicapType: player.handicapType
                               , effectiveOn: player.effectiveOn
                            }
                         }
                         ggFunctions.toggleProcessing(true);
                         ggOutingSvc.player.updatePlayer(post).then(function (data) {

                             if (data) {
                                 for (var t = 0; t < $scope.Outing.teams.length; t++) {
                                     var team = $scope.Outing.teams[t];
                                     if (team.id == teamId) {
                                         for (var p = 0; p < team.players.length; p++) {
                                             if (team.players[p].id == player.id) {
                                                 $scope.Outing.teams[t].players.splice(p, 1);
                                             }
                                         }
                                     }
                                 }
                             }

                         }, function (error) {
                             $scope.PopupAlert.fail("Error", "There was an error removing the player from the team.");
                         }).finally(function () {
                             ggFunctions.toggleProcessing(false);
                         });
                     }
                    , swipe: {
                        selected: 0
                       , left: function (id) {
                           $scope.f.isSwiper();
                           $scope.Content.organize.team.player.swipe.selected = id;
                       }
                       , right: function (id) {
                           $scope.f.isSwiper();
                           $scope.Content.organize.game.player.swipe.selected = 0;
                       }
                       , isSelected: function (id) {
                           return id == $scope.Content.organize.game.player.swipe.selected;
                       }
                    }
                 }
                 , addPlayers: function (teamId, players) {

                     // Array of data to send to api
                     var insertData = [];

                     // check if player is on the schedule
                     var isPlayerOnTeam = function (playerId) {
                         var rv = false;
                         for (var t = 0; t < $scope.Outing.teams.length; t++) {
                             var team = $scope.Outing.teams[t];
                             for (var p = 0; p < team.players.length; p++) {
                                 var player = team.players[p];
                                 if (player.id == playerId) {
                                     rv = true;
                                     break;
                                 }
                             }
                         }
                         return rv;
                     }

                     var fetchTeamUpdate = function () {
                         return ggOutingSvc.team.fetchTeams({ outingId: $scope.Outing.id }).then(function (data) {
                             if (data && data.status == "200") {
                                 $scope.Outing.teams = data.data.value;
                             }
                             return;
                         });
                     }

                     // Loop through all selected players
                     for (var p = 0; p < players.length; p++) {
                         // Append form data.
                         if (!isPlayerOnTeam(players[p].id)) {

                             var post = {
                                 outingId: $scope.Outing.id
                                   , playerId: players[p].id
                                   , form: {
                                       teamId: teamId
                                      , teamOrder: 0
                                      , handicap: players[p].handicap
                                      , handicapType: players[p].handicapType
                                      , effectiveOn: players[p].effectiveOn
                                   }
                             }

                             insertData.push(post);
                         }
                     }

                     // Chain Insert
                     if (insertData.length > 0) {
                         var chain = ggFunctions.qSequence(ggOutingSvc.player.updatePlayer, insertData);
                         ggFunctions.toggleProcessing(true);
                         chain.then(function () {
                             return fetchTeamUpdate();
                         }).finally(function () {
                             ggFunctions.toggleProcessing(false);
                         });
                     }
                 }
              }
           }
           , leaderboard: {
               gameId: 0
               , fetch: function () {

                   $scope.Content.leaderboard.tabs.select(0);
               }
              , tabs: {
                  current: 0
                 , isActive: function (tab) {
                     return $scope.Content.leaderboard.tabs.current == tab;
                 }
                 , select: function (tab) {
                     if (tab > -1) {
                         $scope.Content.leaderboard.gameId = $scope.Outing.games[tab].id;
                     } else {
                         $scope.Content.leaderboard.gameId = 0;
                     }
                     $scope.Content.leaderboard.tabs.current = tab;
                 }
              }
              , share: {
                  url: ""
                 , open: function () {
                     // Get Leaderboard Token
                     ggOutingSvc.search.fetchOutingToken($scope.Outing.id).then(function (data) {
                         if (data) {

                             $scope.Content.leaderboard.share.url = app.Branding.http + app.Branding.rootURL + "#" + app.modules.outing.routes.leaderboard.path + "?tk=" + data.data.publicAccessToken;
                             try {

                                 app.Member.Session.pageTemplates.fetch(app.modules.outing.templates.shareModal.templateId).then(function (template) {

                                     ngDialog.open({
                                         template: template
                                        , plain: true
                                        , closeByEscape: false
                                        , closeByDocument: false
                                        , showClose: true
                                        , className: "slideup alert"
                                        , scope: $scope
                                     });
                                 });
                             } catch (e) {
                                 console.log(e.toString());
                             }

                         }
                     });
                 }
                 , copy: function () {

                 }
                 , close: function () {
                     ngDialog.closeAll();
                 }
              }
           }
        }



        $scope.f = {
            getTheme: function (themeId) {
                var rv = "";
                for (var x = 0; x < ggThemes.length; x++) {
                    if (ggThemes[x].themeId == themeId) {
                        rv = ggThemes[x].className;
                        break;
                    }
                }
                return rv;
            }
           , isSwiper: function () {
               $scope.Temp.isSwiper = true;
               $timeout(function () {
                   $scope.Temp.isSwiper = false
               }, 1000);
           }
           , toggleJumboContent: function () {
               $scope.Temp.isJumboExpanded = !$scope.Temp.isJumboExpanded;
           }
           , formatDateString: function (d) {
               return ggFunctions.formatDateString(d, 'm/d/yyyy', null)
           }
           , isPlayerRosterAvailable: function (Round) {
               var rv = false;
               var players = angular.copy($scope.Outing.players);


               var removePlayer = function (playerId) {
                   for (var r = 0; r < players.length; r++) {
                       if (playerId == players[r].id) {
                           players.splice(r, 1);
                           break;
                       }
                   }
               }

               for (var t = 0; t < Round.teeTimes.length; t++) {
                   var tt = Round.teeTimes[t];
                   for (var p = 0; p < tt.players.length; p++) {
                       removePlayer(tt.players[p].id);
                   }
               }

               if (players.length > 0) {
                   rv = true;
               }

               return rv;
           }
           , pickMembers: function (data) {
               $scope.View.tabs.select($scope.View.tabs.types.invited);
               $scope.Content.invited.tabs.select($scope.Content.invited.tabs.types.add)
               // Should be a list of members
               if (data && data.length > 0) {
                   var ex = 0;

                   var joinGroup = function (memberId) {
                       return ggGroupSvc.membership.autoJoinGroup({ groupId: $scope.Outing.group.id, memberId: memberId });
                   }
                   var joinOuting = function (memberId) {
                       return ggOutingSvc.player.autoJoinOuting({ outingId: $scope.Outing.id, memberId: memberId });
                   }

                   var forms = [];
                   for (var x = 0; x < data.length; x++) {
                       forms.push(data[x].id);
                   }

                   // Auto Join Group..
                   // Auto Join Outing..

                   var automate = function (memberId) {
                       return joinGroup(memberId).then(joinOuting(memberId));
                   }

                   ggFunctions.toggleProcessing(true);
                   ggFunctions.qSequence(automate, forms).then(function () {
                       return ggOutingSvc.player.fetchPlayers({ outingId: $scope.Outing.id }).then(function (data) {
                           if (data && data.status == "200") {
                               $scope.Outing.players = data.data.value;

                               var lst = data.data.value;
                               var results = [];
                               for (var x = 0; x < lst.length; x++) {
                                   results.push(lst[x])
                               }

                               // Sort on Lastname
                               results.sort(function (a, b) {
                                   var d1 = a.member.lastName;
                                   var d2 = b.member.lastName;
                                   var v = d1 > d2 ? 1 : d1 < d2 ? -1 : 0;
                                   return v;
                               });

                               $scope.Content.invited.playing.results = results;

                           }
                           return;
                       });
                   }).finally(function () {

                       ggFunctions.toggleProcessing(false);
                   });


               }
           }
           , pickPlayers: function (data) {
               // Should be a list of members
               if (data && data.parentId) {
                   if (data.players) {
                       $scope.Content.organize.round.addPlayers(data.parentId, data.players);
                   }
                   if (data.teams) {
                       $scope.Content.organize.round.addTeams(data.parentId, data.teams);
                   }
               }
               if (data && data.isNextAction) {
                   $scope.Content.invited.tabs.select($scope.Content.invited.tabs.types.add);
                   $scope.View.tabs.select($scope.View.tabs.types.invited);

               }
           }
           , pickTeamPlayers: function (data) {
               // Should be a list of members
               if (data && data.parentId) {
                   if (data.players) {
                       $scope.Content.organize.team.addPlayers(data.parentId, data.players);
                   }
               }
           }
           , pickGamePlayers: function (data) {
               // Should be a list of members
               if (data && data.parentId) {
                   if (data.players) {
                       $scope.Content.organize.game.addPlayers(data.parentId, data.players);
                   }
               }
           }
           , isOutingStarted: function (d) {
               // The Event Started
               if (!d) {
                   if ($scope.Outing) {
                       d = $scope.Outing.startOn;
                   }
               }
               if (d) {

                   var cDate1 = new Date(ggFunctions.formatDateString(null, 'yyyy-mm-dd', true));
                   var cDate2 = new Date(ggFunctions.formatDateString(d, 'yyyy-mm-dd', true));

                   if (cDate1 >= cDate2) {
                       return true;
                   } else {
                       return false;
                   }
               } else {
                   return false;
               }
           }
           , isOutingEnded: function (d) {
               // The event is over.  no changes should take place 
               if (!d) {
                   if ($scope.Outing) {
                       d = $scope.Outing.rounds[$scope.Outing.rounds.length-1].endOn;
                   }
               }
               if (d) {

                   var cDate1 = new Date(ggFunctions.formatDateString(null, 'yyyy-mm-dd', true));
                   var cDate2 = new Date(ggFunctions.formatDateString(d, 'yyyy-mm-dd', true));

                   if (cDate1 <= cDate2) {
                       return false;
                   } else {
                       return true;
                   }
               } else {
                   return false;
               }
           }
           , isPrivate: function () {
               return $scope.Outing && $scope.Outing.classType == "Public";
           }
           , isPageAdmin: function () {
               return $scope.Outing && $scope.Outing.createdBy.id == app.Member.Detail.id;
           }
           , isLeaderboard: function () {
               return $scope.Outing; // && $scope.f.isOutingStarted();
           }
           , isActive: function () {
               return $scope.Outing && $scope.Outing.status == "Active";
           }
           , isGroupMember: function () {
               return $scope.Temp.isGroupMember;
           }
           , isInvited: function () {
               return $scope.Temp.invitationId != 0;
           }
           , isPlayer: function () {
               return $scope.Temp.myPlayerId != 0;
           }
           , isAssignedTime: function () {
               var rv = false;
               if ($scope.f.isPlayer()) {
                   // Is Assigned Tee Time -> Rounds -> TeeTimes -> Players
                   for (var r = 0; r < $scope.Outing.rounds.length; r++) {
                       var teeTimes = $scope.Outing.rounds[r].teeTimes;
                       for (var t = 0; t < teeTimes.length; t++) {
                           var players = teeTimes[t].players;
                           for (var p = 0; p < players.length; p++) {
                               var player = players[p];
                               if (player.memberId == app.Member.Detail.id) {
                                   rv = true;
                                   break;
                               }
                           }
                       }
                   }
               }


               return rv;
           }
           , permission: {
               canJoin: function () {
                   return $scope.Outing && $scope.f.isActive() && !$scope.f.isOutingStarted() && !$scope.f.isPlayer()
                      && ((!$scope.f.isPrivate() && $scope.f.isGroupMember() && !$scope.f.isInvited()) || $scope.f.isInvited());
               }
              , canLeave: function () {
                  return $scope.Outing && $scope.f.isActive() && !$scope.f.isOutingStarted() && $scope.f.isPlayer()
                     && ($scope.f.isAssignedTime());
              }
              , canAcceptInvite: function () {
                  return $scope.Outing && $scope.f.isActive() && !$scope.f.isOutingEnded() && !$scope.f.isPlayer()
                    && ($scope.f.isInvited());
              }
              , canPostScore: function (data) {

                  var isAlert = data && data.isAlert ? data.isAlert : false
                  var rv = {
                      isAllowed: false
                     , teeTimeId: data && data.teeTimeId ? data.teeTimeId : 0
                     , memberId: data && data.memberId ? data.memberId : app.Member.Detail.id
                     , roundId: 0
                     , courseId: 0
                     , playerId: 0
                     , teamId: 0
                  }

                  if ($scope.f.isActive()) {
                      if (($scope.Temp.myPlayerId != 0) || ($scope.f.isPageAdmin() && rv.memberId > 0)) {

                          // Round / Date Validation
                          var isTeeTime = false;
                          var isPlayer = false;
                          var isDateMatch = false;

                          // loop through the rounds
                          var rounds = $scope.Outing.rounds;
                          for (var r = 0; r < rounds.length; r++) {

                              if (!rounds[r].isLocked){
                              // Check the date of each round and compare to today
                              var cDate1 = new Date(ggFunctions.formatDateString(rounds[r].startOn, 'yyyy-mm-dd', true));
                              var cDate2 = new Date(ggFunctions.formatDateString(null, 'yyyy-mm-dd', true));

                              // if the dates match
                              if (((cDate1 <= cDate2 && !app.Branding.scoreOutingOnDayOfOnly) || (cDate2 - cDate1 == 0 && app.Branding.scoreOutingOnDayOfOnly)) && rounds[r].teeTimes) {
                                  isDateMatch = true;
                                  

                                  if ($scope.f.isPageAdmin()) {
                                      rv.isAllowed = true;
                                  }

                                  for (var t = 0; t < rounds[r].teeTimes.length; t++) {
                                      if (rounds[r].teeTimes[t].id == rv.teeTimeId || rv.teeTimeId == 0) {

                                          isTeeTime = true;
                                          
                                          rv.courseId = rounds[r].teeTimes[t].gameCourseId
                                          //$scope.Temp.Score.courseId = rounds[r].teeTimes[t].gameCourseId;

                                          //  We still place each player on a teetime
                                          if ($scope.Outing.games[0].gameType == "Team") {
                                              // Teams
                                              var teams = rounds[r].teeTimes[t].teams;
                                              for (var m = 0; m < teams.length; m++) {
                                                  var team = teams[m];
                                                  // is the player on this team?
                                                  var teamPlayerId = $scope.f.isTeamPlayer(team.id, rv.memberId);
                                                  if (teamPlayerId > 0) {
                                                      rv.isAllowed = true;
                                                      isPlayer = true;
                                                      rv.teamId = team.id;
                                                      rv.playerId = teamPlayerId;
                                                      //$scope.Temp.Score.teamId = team.id;
                                                      //$scope.Temp.Score.playerId = teamPlayerId;

                                                      if (rv.teeTimeId == 0) {
                                                          rv.teeTimeId = rounds[r].teeTimes[t].id
                                                          rv.roundId = rounds[r].id
                                                          // $scope.Temp.Score.teeTimeId = rounds[r].teeTimes[t].id;
                                                          // $scope.Temp.Score.roundId = rounds[r].id;
                                                      }

                                                      break;
                                                  }
                                              }
                                          } else {
                                              // Players
                                              var players = rounds[r].teeTimes[t].players;
                                              for (var p = 0; p < players.length; p++) {
                                                  if ((players[p].member && players[p].member.id == rv.memberId)) {
                                                      rv.isAllowed = true;
                                                      isPlayer = true;
                                                      rv.playerId = players[p].id;
                                                      //$scope.Temp.Score.playerId = players[p].id;

                                                      if (rv.teeTimeId == 0) {
                                                          rv.teeTimeId = rounds[r].teeTimes[t].id
                                                          rv.roundId = rounds[r].id
                                                          // $scope.Temp.Score.teeTimeId = rounds[r].teeTimes[t].id;
                                                          // $scope.Temp.Score.roundId = rounds[r].id;
                                                      }

                                                      break;
                                                  }
                                              }
                                          }
                                      }
                                      if (isPlayer) {
                                          break;
                                      }
                                  }
                              }
                          }
                              if (isPlayer) {
                                  break;
                              }
                          }

                          if (!isTeeTime) {
                              if (isAlert) {
                                  $scope.PopupAlert.warn("", "You cannot post a score until a tee time has been set and the event has started.");
                              }
                          } else {
                              if (!isDateMatch) {
                                  if (isAlert) {
                                      $scope.PopupAlert.warn("", "You cannot post a score until the date of the outing.");
                                  }
                              } else {
                                  if (!isPlayer) {
                                      if (isAlert) {
                                          $scope.PopupAlert.warn("", "You have not been assigned a tee time.");
                                      }
                                  }
                              }
                          }
                      }
                  }
                  return rv;
              }
           }
           , notFound: function () {
               var btn = new ggAlertSvc.button;
               btn.name = "Continue";
               btn.path = app.modules.view.routes.intro.path;
               $scope.PopupAlert.fail("Fore!", "The outing was not found.  Tap continue to start over.", [btn]);
           }
           , notAvailable: function () {
               var btn = new ggAlertSvc.button;
               btn.name = "Continue";
               btn.path = app.modules.view.routes.intro.path;
               $scope.PopupAlert.warn("Patience", "The outing you requested is not ready to view.  Try again soon...", [btn]);
           }
           , join: function () {
               // Insert Player
               var insertPlayer = function () {
                   var form = {
                       outingId: $scope.Outing.id
                      , memberId: app.Member.Detail.id
                      , handicap: app.Member.Network.Data.Handicap.official.value
                      , effectiveOn: app.Member.Network.Data.Handicap.official.effectiveOn
                   }
                   return ggOutingSvc.player.insertPlayer(form).then(function (data) {
                       if (data && data.status == "201") {
                           $scope.Temp.myPlayerId = data.data.id;
                       }
                       return;
                   }, function (error) {
                       return $q.resolve();
                   });
               }
               // Refresh Member Token
               var refreshMemberToken = function () {
                   return app.Member.Authenticate.RefreshToken();
               }
               // Refresh Player List
               var fetchPlayers = function () {
                   return ggOutingSvc.player.fetchPlayers({ outingId: $scope.Outing.id }).then(function (data) {
                       if (data && data.status == "200") {
                           $scope.Outing.players = data.data.value;
                       }
                       return;
                   });
               }

               if ($scope.Temp.myPlayerId == 0) {
                   // Process
                   ggFunctions.toggleProcessing(true);
                   insertPlayer().then(function () {
                       return refreshMemberToken();
                   }).then(function () {
                       return fetchPlayers()
                   }).finally(function () {
                       ggFunctions.toggleProcessing(false);
                       if ($scope.f.isPageMember()) {
                           $scope.PopupAlert.success("Welcome", "Welcome to the outing.  Once tee times are ready, we'll let you know!");
                       } else {
                           $scope.PopupAlert.fail("Error", "There was an error processing the invitation.");
                       }
                   });
               }
           }
           , leave: function () {
               // Delete Player
               var deletePlayer = function () {
                   var form = {
                       outingId: $scope.Outing.id
                      , playerId: $scope.Temp.myPlayerId
                   }
                   return ggOutingSvc.player.deletePlayer(form).then(function (data) {
                       if (data && data.status == "204") {
                           $scope.Temp.myPlayerId = 0;
                       }
                       return;
                   }, function (error) {
                       return $q.resolve();
                   });
               }
               // Refresh Member Token
               var refreshMemberToken = function () {
                   return app.Member.Authenticate.RefreshToken();
               }
               // Refresh Player List
               var fetchPlayers = function () {
                   return ggOutingSvc.player.fetchPlayers({ outingId: $scope.Outing.id }).then(function (data) {
                       if (data && data.status == "200") {
                           $scope.Outing.players = data.data.value;
                       }
                       return;
                   });
               }

               if ($scope.Temp.myPlayerId > 0) {
                   // Process
                   ggFunctions.toggleProcessing(true);
                   deletePlayer().then(function () {
                       return refreshMemberToken();
                   }).then(function () {
                       return fetchPlayers()
                   }).finally(function () {
                       ggFunctions.toggleProcessing(false);
                       if ($scope.f.isPageMember()) {
                           $scope.PopupAlert.success("Goodbye", "You have been removed from the outing.");
                       } else {
                           $scope.PopupAlert.fail("Error", "There was an error processing the removal.");
                       }
                   });
               }
           }
           , acceptInvite: function () {
               var updateInvitation = function () {
                   var form = {
                       id: $scope.Temp.invitationId
                      , responseType: ggInvitationSvc.responseTypes.accept
                      , memberId: app.Member.Detail.id
                   };
                   return ggInvitationSvc.invite.updateInvitationResponse(form).then(function (data) {
                       app.Member.Network.Data.Invitations.unfollow($scope.Temp.invitationId);// remove invite from my object
                       ggStorage.set(ggStorage.keys.invitations.my.isCurrent, false); // Not current local invitations
                       $scope.Temp.invitationId = 0;
                       return;
                   });
               }
               var updateOutingMembership = function () {
                   return ggOutingSvc.player.autoJoinOuting({ outingId: $scope.Outing.id, memberId: app.Member.Detail.id }).then(function (data) {
                       if (data) {
                           $scope.Temp.myPlayerId = data.data.playerId;
                       }
                       return;
                   }, function (error) {
                       isError = true;
                       msg = "There was an error updating the player record.";
                       return;
                   });
               }
               // Refresh Member Token
               var refreshMemberToken = function () {
                   return app.Member.Authenticate.RefreshToken();
               }
               // Refresh Player List
               var fetchPlayers = function () {
                   return ggOutingSvc.player.fetchPlayers({ outingId: $scope.Outing.id }).then(function (data) {
                       if (data && data.status == "200") {
                           $scope.Outing.players = data.data.value;

                           var lst = data.data.value;

                           // Sort on Lastname
                           lst.sort(function (a, b) {
                               var d1 = a.member.lastName;
                               var d2 = b.member.lastName;
                               var v = d1 > d2 ? 1 : d1 < d2 ? -1 : 0;
                               return v;
                           });

                           $scope.Content.invited.playing.results = lst;

                       }
                       return;
                   });
               }

               // Process
               ggFunctions.toggleProcessing(true);
               updateInvitation().then(function () {
                   return updateOutingMembership()
               }).then(function () {
                   return refreshMemberToken();
               }).then(function () {
                   return fetchPlayers()
               }).finally(function () {
                   ggFunctions.toggleProcessing(false);
                   if ($scope.f.isPageMember()) {
                       $scope.PopupAlert.success("Welcome", "Welcome to the outing.  Once tee times are ready, we'll let you know!");
                   } else {
                       $scope.PopupAlert.fail("Error", "There was an error processing the invitation.");
                   }
               });
           }
           , postScore: function (data) {


               $scope.Temp.Score.teeTimeId = data && data.teeTimeId ? data.teeTimeId : 0;
               var teeId = data && data.teeId ? data.teeId : null;
               $scope.Temp.Score.memberId = data && data.memberId ? data.memberId : app.Member.Detail.id;

               // Combined Team Scoring
               if ($scope.Outing.games[0].scoringType == "Scramble" || $scope.Outing.games[0].scoringType == "AlternateShot") {
                   $scope.Temp.Score.isTeamScore = true;
               }

               var canPostData = $scope.f.permission.canPostScore({ teeTimeId: $scope.Temp.Score.teeTimeId, memberId: $scope.Temp.Score.memberId, isAlert: true });
               if (canPostData.isAllowed) {
                   if (canPostData.teeTimeId > 0 && (canPostData.playerId || canPostData.teamId)) {

                       var form = {
                           outingId: $scope.Outing.id
                          , teeTimeId: canPostData.teeTimeId
                          , playerId: $scope.Temp.Score.isTeamScore ? null : canPostData.playerId
                          , teamId: (canPostData.teamId == 0) ? null : canPostData.teamId
                          , gameTeeId: teeId
                          , isTeamScore: $scope.Temp.Score.isTeamScore
                       }

                       var gameScoreId = 0;

                       // Check if Score Exists
                       var scoreCheck = function (form) {
                           return ggScoringSvc.score.fetchGameScores(form).then(function (data) {
                               if (data) {
                                   if (data.data.value.length > 0) {
                                       gameScoreId = data.data.value[0].id;
                                   }
                               }
                               return;
                           }, function (error) {
                               return $q.resolve();
                           });
                       }

                       // Fetch Course Detail // Assign to 
                       var fetchCourseDetail = function () {
                           return ggOutingSvc.course.fetchCourses({ outingId: outingId }).then(function (data) {
                               if (data && data.status == "200") {
                                   $scope.Outing.gameCourses = data.data.value;
                               }
                               return;
                           }, function (error) {
                               return $q.resolve();
                           });
                       }
                       // Insert new score
                       var insertNewScore = function (form) {
                           return ggScoringSvc.score.insertGameScore(form).then(function (data) {
                               if (data && data.status == "201") {
                                   gameScoreId = data.data.id;
                               }
                               return;
                           }, function (error) {
                               return error;
                           });
                       }
                       // Open tee selection
                       var openTees = function () {

                           var scope = $scope.$new();
                           scope.teeTimeId = canPostData.teeTimeId;
                           scope.memberId = canPostData.memberId;
                           scope.courseId = canPostData.courseId;


                           $timeout(function () {
                               ngDialog.open({
                                   template: ggFunctions.cacheBuster(app.modules.outing.templates.teeModal.templateId)
                                  , closeByEscape: true
                                  , closeByDocument: false
                                  , className: "fullscreen"
                                  , scope: scope
                               });
                           }, 50);
                           return $q.resolve();
                       }


                       ggFunctions.toggleProcessing(true);
                       scoreCheck(form).then(function () {
                           if (gameScoreId > 0) {
                               return $q.resolve();
                           } else {
                               if (!teeId) {
                                   return fetchCourseDetail().then(function () {
                                       return openTees();
                                   });
                               } else {
                                   return insertNewScore(form);
                               }
                           }
                       }).finally(function () {
                           ggFunctions.toggleProcessing(false);
                           // Game Score Exists, goTo
                           if (gameScoreId > 0) {
                               ngDialog.closeAll();
                               $timeout(function () {
                                   ggFunctions.goToPage(app.modules.scoring.routes.postaround.path + "?outingId=" + $scope.Outing.id + "&gameScoreId=" + gameScoreId);
                               }, 50);
                           }
                       });

                   }
               }
           }
           , addCourse: function (course) {
               if (course) {
                   var data = {
                       outingId: $scope.Outing.id
                         , number: $scope.Outing.gameCourses.length + 1
                         , course: course
                   }
                   ggFunctions.toggleProcessing(true);
                   ggOutingSvc.course.insertCourse(data).then(function (data) {
                       if (data && data.status == "201") {
                           // Save to form.
                           ggOutingSvc.course.fetchCourses({ outingId: outingId }).then(function (data) {
                               if (data && data.status == "200") {
                                   $scope.Outing.gameCourses = data.data.value;
                               }
                           });
                       } else {
                           $scope.PopupAlert.fail("Error", ggMessaging.api.badresponse);
                       }
                   }, function (error) {
                       $scope.PopupAlert.fail("Error", "There was an error inserting the course information.");
                   }).finally(function () {
                       ggFunctions.toggleProcessing(false);

                   });
               }
           }
           , addRoundStartOn: function (data) {
               if (data) {

                   // Check fo rChanged Dates
                   $scope.Content.organize.round.setup.isUpdated = true;
                   $scope.Content.organize.round.setup.form.startOn = data.date;
                   $scope.Content.organize.round.setup.form.endOn = data.date;
               }
           }
           , updateTime: function (data) {
               if (data) {
                   $scope.Content.organize.round.teetime.form.startingTime = data.time;
               }
           }
           , renderCourseName: function (courseId) {
               for (var x = 0; x < $scope.Outing.gameCourses.length; x++) {
                   if ($scope.Outing.gameCourses[x].id == courseId) {
                       return $scope.Outing.gameCourses[x].facilityName;
                   }
               }
           }
           , renderTime: function (time) {
               return ggFunctions.parseDBTime(time);
           }
           , isTeamPlayer: function (teamId, memberId) {
               var rv = 0;
               // is the player on this team?
               var teams = $scope.Outing.teams;
               for (var t = 0; t < teams.length; t++) {
                   // Append form data.
                   if (teams[t].id == teamId) {
                       for (var p = 0; p < teams[t].players.length; p++) {
                           if (teams[t].players[p].member.id == memberId) {
                               rv = teams[t].players[p].id;
                               break;
                           }

                       }
                   }
               }
               return rv;
           },
            getHandicapTypeDisplay: function (player) {
                var
                    getHandicapTypeDisplay = $scope.f.getHandicapTypeDisplay,
                    handicapTypes = $scope.Temp.handicapTypes,
                    map = getHandicapTypeDisplay._map || (getHandicapTypeDisplay._map = []),
                    result = map[player.handicapType];

                return player.isHandicapAdjusted ? 'Adjusted' :
                    !angular.isUndefined(result) ? result :
                    map[player.handicapType] = handicapTypes
                        .filter(function filter(type) { return type.name == player.handicapType; })
                        .map(function map(type) { return type.displayName; })[0] || '';
            }
        }

        // Page Startup
        if ($routeParams) {
            if (!$routeParams.outingId) {
                // No Outing Id.  Shame on you.
                $scope.Content.init();
            } else {
                var outingId = Number($routeParams.outingId);
                var isNew = false;
                var ttCnt = 1;
                var newOuting = {};

                // Outing
                var fetchOuting = function (outingId) {
                    return ggOutingSvc.search.fetchOutingDetail(outingId).then(function (data) {
                        newOuting = data.data;
                        if (!newOuting.teams) {
                            newOuting.teams = [];
                        }
                        if (!newOuting.games) {
                            newOuting.games = [];
                        }

                        $scope.Content.home.tabs.currentIndex = newOuting.rounds.reduce(function (prev, round, index) {
                            return round.teeTimes.some(function (teeTime) { return teeTime.isScored; }) ? index : prev;
                        }, 0);

                        return;
                    }, function (error) {
                        return;
                    });
                }
                // Rounds
                var fetchRounds = function (outingId) {
                    /*
                    return ggOutingSvc.round.fetchRounds({ outingId: outingId }).then(function (data) {
                        newOuting.rounds = data.data.value;
                        return;
                    }, function (error) {
                        return $q.resolve();
                    });
                    */

                    //Add player info to Round/teetime

                    function getMemberInfo(playerId) {
                        for (var o = 0; o < newOuting.players.length; o++) {
                            if (newOuting.players[o].id == playerId) {
                                return newOuting.players[o].member;
                            }
                        }
                        return null;
                    }

                    for (var r = 0; r < newOuting.rounds.length; r++) {
                        var round = newOuting.rounds[r];
                        for (var tt = 0; tt < round.teeTimes.length; tt++) {
                            var time = round.teeTimes[tt];
                            for (var p = 0; p < time.players.length; p++) {
                                time.players[p].member = getMemberInfo(time.players[p].id);
                            }
                        }
                    }
                }
                // Games
                var fetchGames = function (outingId) {
                    return ggOutingSvc.game.fetchGames({ outingId: outingId }).then(function (data) {
                        newOuting.games = data.data.value;
                        return;
                    }, function (error) {
                        return;
                    });
                }
                // Teams
                var fetchTeams = function (outingId) {
                    return ggOutingSvc.team.fetchTeams({ outingId: outingId }).then(function (data) {
                        newOuting.teams = data.data.value;
                        return;
                    }, function (error) {
                        return;
                    });
                }


                // Process
                ggFunctions.toggleProcessing(true);
                fetchOuting(outingId).then(function () {
                    return fetchRounds(outingId);
                })/*.then(function () {
                    return fetchGames(outingId);
                })*/
                .then(function () {
                    if (newOuting.games && newOuting.games.length > 0 && newOuting.games[0].gameType != "Individual") {
                        return fetchTeams(outingId);
                    } else {
                        return $q.resolve();
                    }
                }).finally(function () {
                    //ggFunctions.toggleProcessing(false); // handled in init.

                    if ($routeParams.isNew) {
                        $scope.Temp.isNew = true;
                    }

                    if (newOuting.id) {
                        $scope.Outing = newOuting;
                    }
                    $scope.Content.init();
                });
            }
        }

        vm.memories = null;
        vm.outingId = +$routeParams.outingId;
        vm.addMemory = addMemory;
        vm.getMemoryList = getMemoryList;
        vm.memoriesEnabled = false;

        function parseDate(dateString) {
            var match = rDateExtract.exec(dateString);
            return match ? new Date(match[1], match[2] - 1, match[3]) : null;
        }

        function addMemory() {
            $scope.memoryList.addMemory();
        }

        function getMemoryList() {
            ggFunctions.toggleProcessing(true);
            vm.memories = Memory.queryByOuting({ outingId: vm.outingId });
            vm.memories.$promise.finally(ggFunctions.toggleProcessing.bind(ggFunctions, false));
        }

        function getMemoryListNew(options) {
            options = angular.extend({ outingId: vm.outingId }, options);
            return Memory.queryByOuting(options).$promise;
        }
    }
}(angular, app));

